"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_apollo_1 = require("react-apollo");
const utilities_1 = require("../utilities");
const { AsyncSelect, AsyncCreatableSelect } = require("@atlaskit/select");
class QuerySelectView extends React.Component {
    constructor(props) {
        super(props);
        this.loadOptions = (inputValue) => this.props.loadOptions(inputValue, this.props.client.query);
        // Hack to get AsyncSelect to query when the dropdown is opened
        this.queryOnFocus = () => {
            if (this.state.ref.select.select && this.state.ref.select.select.value) {
                this.state.ref.select.handleInputChange(this.state.ref.select.select.state.value.value);
            }
        };
        this.state = { ref: undefined };
    }
    render() {
        return (React.createElement(AsyncSelect, Object.assign({}, this.props, { ref: (ref) => {
                if (!this.state.ref) {
                    this.setState({ ref });
                }
            }, loadOptions: this.loadOptions })));
    }
}
exports.QuerySelectView = QuerySelectView;
exports.QuerySelect = utilities_1.compose(react_apollo_1.withApollo)(QuerySelectView);
exports.QuerySelect.displayName = "QuerySelect";
class QueryCreatableSelectView extends React.Component {
    constructor(props) {
        super(props);
        this.loadOptions = (inputValue) => this.props.loadOptions(inputValue, this.props.client.query);
        // Hack to get AsyncSelect to query when the dropdown is opened
        this.queryOnFocus = () => {
            if (this.state.ref.select.select && this.state.ref.select.select.value) {
                this.state.ref.select.handleInputChange(this.state.ref.select.select.state.value.value);
            }
        };
        this.state = { ref: undefined };
    }
    render() {
        return (React.createElement(AsyncCreatableSelect, Object.assign({}, this.props, { ref: (ref) => {
                if (!this.state.ref) {
                    this.setState({ ref });
                }
            }, loadOptions: this.loadOptions })));
    }
}
exports.QueryCreatableSelectView = QueryCreatableSelectView;
exports.QueryCreatableSelect = utilities_1.compose(react_apollo_1.withApollo)(QueryCreatableSelectView);
exports.QueryCreatableSelect.displayName = "QueryCreatableSelectView";
